import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-pilates',
	additionalCrmLinks: [
		{
			name: 'Link to Paywall (short plans)',
			routeName: 'plan-email-pilates',
		},
	],
	options: {
		userFlags: ['hasAccessToPilatesVideos'],
		userTags: ['pilates'],
	},
	landing: {
		ids: ['loader-pilates-f', 'age-pilates-f'],
		route: {
			path: '/pilates-f',
			name: 'female-pilates-funnel',
		},
		overrides: [
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-female-pilates', 'age-pilates-f'],
			},
			{
				matcher: {
					$and: {
						utm_campaign: /search/,
						utm_content: /wallpilates/,
					},
				},
				ids: ['creatives-search-wall-pilates', 'age-pilates-f'],
			},
			{
				matcher: {
					lptype: 'female_funnel', // /pilates-f?safe&lptype=female_funnel&lpid=
				},
				ids: ['dynamic-loader-female', 'dynamic-age-f-18-50'],
			},
		],
	},
	funnel: {
		id: 'ob-yoga-narrative-on-pilates',
		route: {
			path: '/pilates-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-pilates',
		},
		slug: 'activity-female-pilates',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-pilates-f-commitment',
		overrides: [
			{
				matcher: { country: 'us' },
				routeName: 'plan-pilates-f-commitment-us',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
	upgrade: {
		routeName: 'special-upsale',
	},
}

export default appAreaConfig
